"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const check_1 = require("../icons/check");
exports.default = check_1.Check;
